module.exports = __webpack_public_path__ + "img/bounding-box-circles.c9fa1fd7.svg";